import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { authState } from '../recoil/authState';
import { Suspense } from 'react';
import Layout from '../layouts';
import useAuth from '../hooks/useAuth';

const PrivateRoute = () => {
    const { isLoading: isAuthLoading, user, isInvalidUser } = useAuth();

    // return  <SreenCoverLoading />

    if (isAuthLoading) {
        return <></>;
    }
    if (isInvalidUser) {
        return <>유저정보 없음</>;
    }
    return <Outlet />;
};

export default PrivateRoute;
